import { render, staticRenderFns } from "./Emprestimos.vue?vue&type=template&id=b03d744a&"
import script from "./Emprestimos.vue?vue&type=script&lang=js&"
export * from "./Emprestimos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports